/* الصورة الجماعية لفريق العمل — غلاف موحّد لكل صفحات الموقع.
   ثابتة في الكود عمداً: كانت الأغلفة تُقرأ من siteContent في قاعدة البيانات،
   فكانت قيَم قديمة (روابط unsplash، أو نسخة محفوظة في localStorage) تتخطّى الغلاف الموحّد. */
export const DEFAULT_PAGE_HEADER = '/Photo gallery/PhotoGallery04.jpg';

/* غلاف خاص بصفحة المنتجات — بانر "OUR PRODUCTS" الجاهز من التصميم. */
export const PRODUCTS_PAGE_HEADER = '/banners/products-header.jpg';

/* غلاف صفحة "من نحن" — صورة رئيس مجلس الإدارة في مكتبه. */
export const ABOUT_PAGE_HEADER = '/banners/about-header.jpg';

/* غلاف صفحة "معرض الصور" — خط إنتاج رولات الورق داخل المصنع. */
export const GALLERY_PAGE_HEADER = '/banners/gallery-header.jpg';

/* غلاف صفحة "عملاؤنا" — عامل يجهّز علب المناديل على خط التعبئة. */
export const CLIENTS_PAGE_HEADER = '/banners/clients-header.jpg';

/* غلاف صفحة "تواصل معنا" — بانر "Intimate with Hygiene" الجاهز من التصميم. */
export const CONTACT_PAGE_HEADER = '/banners/contact-header.jpg';
